import React from 'react';

export function Greece(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="513" height="342" fill="#0D5EAF"/>
      <path d="M0 0H513V38H0V0Z" fill="#0D5EAF"/>
      <path d="M0 38H513V76H0V38Z" fill="white"/>
      <path d="M0 76H513V114H0V76Z" fill="#0D5EAF"/>
      <path d="M0 114H513V152H0V114Z" fill="white"/>
      <path d="M0 152H513V190H0V152Z" fill="#0D5EAF"/>
      <path d="M0 190H513V228H0V190Z" fill="white"/>
      <path d="M0 228H513V266H0V228Z" fill="#0D5EAF"/>
      <path d="M0 266H513V304H0V266Z" fill="white"/>
      <path d="M0 304H513V342H0V304Z" fill="#0D5EAF"/>
      <rect x="0" y="0" width="190" height="152" fill="#0D5EAF"/>
      <rect x="76" y="0" width="38" height="152" fill="white"/>
      <rect x="0" y="57" width="190" height="38" fill="white"/>
    </svg>
  );
}
